var fn_search_sort = function () {

  var item_active = $('.block-search-sort').find('.menu-item.is-active').text();
  $('.block-search-sort .search-sort-btn span').text(item_active);

}
